"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Application_instances, _Application_render;
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const App_1 = __importDefault(require("./App"));
const application_1 = require("./config/application");
require("./index.css");
const EmotionWrapper_1 = __importDefault(require("./wrappers/EmotionWrapper"));
// eslint-disable-next-line node/no-process-env -- need to use process.env
if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line node/no-unsupported-features/es-syntax -- need to ignore this
    void Promise.resolve().then(() => __importStar(require('./mocks/browser'))).then(({ worker }) => __awaiter(void 0, void 0, void 0, function* () { return worker.start(); }));
}
class Application extends HTMLElement {
    constructor() {
        super();
        _Application_instances.add(this);
        // Define the `this.shadowRoot` readonly property by calling `attachShadow`.
        this.attachShadow({ mode: 'open' });
    }
    connectedCallback() {
        __classPrivateFieldGet(this, _Application_instances, "m", _Application_render).call(this);
    }
    attributeChangedCallback(attribute, _previous, next) {
        __classPrivateFieldGet(this, _Application_instances, "m", _Application_render).call(this, { [attribute]: next });
    }
}
_Application_instances = new WeakSet(), _Application_render = function _Application_render(properties) {
    (0, react_dom_1.render)((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(EmotionWrapper_1.default, Object.assign({ shadowRoot: this.shadowRoot }, { children: (0, jsx_runtime_1.jsx)(App_1.default, Object.assign({}, properties)) })) }), this.shadowRoot);
};
customElements.define(application_1.customElementTagName, Application);
